import IThreeFiberComponent from "../../../../../interfaces/IThreeFiberComponent";
import FloorWrapper from "../../../../../components/fiber-components/FloorWrapper";
import { useRouterStore } from "../../../../../store/useRouterStore";
import { HALL_ID } from "../../../../../configs/HALLS_CONFIG";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { animateShowBlackBanner } from "../../../../../animations/animateBlackBanner";

const Index: IThreeFiberComponent = () => {
  const router = useRouter();
  const { setHallID, setBoothID, hallID, boothID } = useRouterStore();

  useEffect(() => {
    setBoothID("");
    if (router.query[HALL_ID] === hallID) return;
    animateShowBlackBanner(() => setHallID(router.query[HALL_ID] as string));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, hallID, boothID]);
  return <></>;
};

Index.r3f = () => {
  return <FloorWrapper />;
};
Index.title = "Exhibition | Building Center";

export default Index;
